/** ***********
*
* <zone.service.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from 'src/app/models/planning';
import { Zone, ZoneUpdate } from 'src/app/models/zone';
import { CacheDeltaResponse } from '../models/cache';

export interface ReducedZone {
  name: string;
  id: string;
  levels: Location;
}

@Injectable({
    providedIn: 'root'
})
export class ZoneService {

    constructor(private http: HttpClient) { }

    /**
     * return zones in the map
     */
    public getZones(delta?: string): Observable<CacheDeltaResponse<Zone>> {
        return this.http.get<CacheDeltaResponse<Zone>>(`${environment.API_ENDPOINT}/zones`,
        );
    }

    // Zone delta call
    // public getZones(delta?: string): Observable<CacheDeltaResponse<Zone>> {
    //     // let params = new HttpParams();

    //     // if (delta !== undefined) {
    //     //     params = params.set('delta', delta);
    //     // }
    //     return this.http.get<CacheDeltaResponse<Zone>>(`${environment.API_ENDPOINT}/zones`,
    //         // { params }
    //     );
    // }
    /**
     * Edit a zone
     * @param zone The zone to edit
     */
    public editZone(zoneId: string, zone: ZoneUpdate): Observable<Zone> {
        return this.http.put<Zone>(
            `${environment.API_ENDPOINT}/zones/${zoneId}`,
            JSON.stringify(zone)
        );
    }

    /**
     * Reduce the zones into objects containing the zone id, the concatenation of the name of the zone and its parents, and the levels (zone and parents)
     * @param zones The zones to reduce
     * @returns The reduced zones with their levels and concatenated name
     */
    public reduceZoneWithLevels(zones: Zone[]): ReducedZone[] {
      return zones.map(
        zone => {
          let zone2: Zone;
          let zone1: Zone;
          /* eslint-disable no-fallthrough */
          switch (+zone.zoneLevel) {
            case 3:
              zone2 = zones.find(z => z.id === zone.parent);
            case 2:
              zone1 = zones.find(z => z.id === (zone2?.parent ?? zone.parent));
          }
          /* eslint-enable no-fallthrough */
          const levels: Location = {
            level1: zone1 ?? zone,
          };
          if (zone1) {
            levels.level2 = zone2 ?? zone;
          }
          if (zone2) {
            levels.level3 = zone;
          }
          return {
            id: zone.id,
            name: `${zone.name}${zone1 ? ` (${zone1.name}${zone2 ? ` > ${zone2.name}` : ''})` : ''}`,
            levels,
          };
        }
      );
    }
}
